import { APIS } from '../../../../../utils/api-factory'
import LocalStrorageUtility from '../../../../../utils/localStorageUtil'
import moment from 'moment'
import axios from 'axios'

export const getBatteryDetailsList = ( callBack, error) => {
    axios.get(APIS.GET_BATTERY_LIST_DETAILS)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const SaveBatteryData = (data, callBack, error) => {
    axios.post(APIS.SAVE_BATTERY_DATA, data)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const UpdateBatteryData = (data, callBack, error) => {
    axios.post(APIS.UPDATE_BATTERY_DATA, data)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const DeleteBatteryData = (id, callBack, error) => {
    axios.delete(APIS.DELETE_BATTERY_DATA + id)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}